export function RetailerService($http, apexApiUrl) {
    'ngInject'
    return {
        retrieveRetailers: retrieveRetailers
    };

    function retrieveRetailers() {
        return $http({
            method: "GET",
            headers: { Accept: "application/json" },
            url: apexApiUrl + "retailers"
        }).then(function (response) {
            return response.data;
        });
    }
}
